document.addEventListener("DOMContentLoaded", function() {
  setTimeout(function() {
    // TOPのマガジン・ニュースコンテンツの削除
    document.querySelectorAll('.sectionTitle').forEach((divElement) => {
      const h2Element = divElement.querySelector('h2');
      if (h2Element && ["MAGAZINE", "NEWS", "SPECIAL CONTENTS"].includes(h2Element.textContent.trim())) {
        divElement.remove();
      }
    });

    // ヘッダーのキャンペーンの項目をエコサイクルに変更
    // const contactItem = document.getElementById('HeaderMenu-campaign_キャンペーン');
    // if (contactItem) {
    //   const currentUrl = window.location.href;
    //   let newLink = '<a style="padding: 0;" id="HeaderMenu-eco_cycle_program" href="';
    //   if (currentUrl.includes('/ko')) {
    //     newLink += '/ko/pages/eco_cycle_program';
    //   } else if (currentUrl.includes('/zh-hant')) {
    //     newLink += '/zh-hant/pages/eco_cycle_program';
    //   } else if (currentUrl.includes('/en')) {
    //     newLink += '/en/pages/eco_cycle_program';
    //   } else {
    //     newLink += '/pages/eco_cycle_program';
    //   }
    //   newLink += '" class="header__menu-item list-menu__item link link--text focus-inset"><span>ECO CYCLE<br>PROGRAM<br role="presentation"><span class="customHeader_subtitle"></span></span></a>';
    //   contactItem.innerHTML = newLink;
    // }

    // フッターの一部非表示
    document.querySelectorAll('.footer-block').forEach((block, index) => {
      if ([9, 7, 6].includes(index)) {
        block.remove();
      }
    });

    document.querySelectorAll('.list-menu__item').forEach((item) => {
      if (["MEMBERSHIP PROGRAM", "NEWS", "MAGAZINE"].includes(item.textContent.trim())) {
        item.remove();
      }
    });

    // bottom-section 内のリンクを無効化
    document.querySelectorAll('.bottom-section a').forEach(link => {
      link.addEventListener('click', function(event) {
        event.preventDefault();
      });
      link.style.pointerEvents = 'none';
      link.style.cursor = 'default';
    });
  }, 1000);
});